import type { SearchResults, SearchResultsv1 } from '@sparkai/shared-types'

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

interface SearchQueryRequest {
  term: string
}

export interface SearchV3QueryRequest extends SearchQueryRequest {
  scope?: 'live'
}

export const SEARCH_QUERY_KEY = 'search-query'

/**
 * @deprecated Use useSearchV3 instead
 */
export function useSearchV1(params: SearchQueryRequest) {
  return useQuery({
    queryKey: [SEARCH_QUERY_KEY, params],
    queryFn: async () => {
      const { data } = await apiClient.post('int/search', { ...params })
      return data
    },
    enabled: params.term.length >= 3,
    select: (data: SearchResultsv1) => {
      return {
        programs: data.programs.map((program) => ({
          ...program,
          imageUrl: program.image_url,
          orgName: program.org_name,
        })),
        operators: data.operators.map((operator) => ({
          ...operator,
          imageUrl: operator.image_url,
          orgName: operator.org_name,
        })),
        orgs: data.orgs.map((org) => ({
          ...org,
          imageUrl: org.image_url,
          orgName: org.org_name,
        })),
        engagements: data.engagements.map((engagement) => ({
          ...engagement,
          imageUrl: engagement.image_url,
          orgName: engagement.org_name,
        })),
        systems: [],
      }
    },
  })
}

export function useSearchV3(params: SearchV3QueryRequest) {
  return useQuery<SearchResults>({
    queryKey: [SEARCH_QUERY_KEY, params],
    queryFn: async () => {
      const { data } = await apiClient.post('int/v3/search', { ...params })
      return data
    },
    enabled: params.term.length >= 3,
  })
}
